/* Pouch 3D FANS: CSS 3D drag — SIEMPRE de frente por default (feedback Samuel), sin autospin.
   Expone window.FansMountPouch(el) para montar un slot puntual (PDP toggle 3D/Foto lo llama
   porque este script corre en defer ANTES del inline de la section). */
(function(){
  function mount(st){
    if(!st || st._pouchMounted) return;                      /* guard doble-mount */
    var front = st.dataset.front, back = st.dataset.back;
    if(!front || !back) return;
    st._pouchMounted = true;
    var img = st.querySelector("img"); if(img) img.style.display = "none";
    st.insertAdjacentHTML("beforeend",
      '<div class="pouch-world"><div class="pouch" style="transform:rotateY(0deg)">' +
      '<div class="pouch-face pouch-front" style="background-image:url(\''+front+'\')"></div>' +
      '<div class="pouch-face pouch-back" style="background-image:url(\''+back+'\')"></div>' +
      '</div></div><span class="pouch-hint">Arrastra &middot; 3D</span>');
    var pouch = st.querySelector(".pouch"), ry = 0, vy = 0, px = 0, dragging = false, raf = null;
    function render(){ pouch.style.transform = "rotateY(" + ry.toFixed(2) + "deg)"; }
    function tick(){
      if(!dragging){ vy *= .93; ry += vy;
        var snap = Math.round(ry/360)*360;               /* vuelve suave al frente */
        if(Math.abs(vy) < .08){ ry += (snap-ry)*.07; if(Math.abs(snap-ry)<.05){ ry = snap; render(); raf=null; return; } }
      }
      render(); raf = requestAnimationFrame(tick);
    }
    function down(x){ dragging = true; px = x; if(!raf) raf = requestAnimationFrame(tick); }
    function move(x){ if(!dragging) return; vy = (x-px)*.45; ry += vy; px = x; }
    st.addEventListener("pointerdown", function(e){ st.setPointerCapture(e.pointerId); down(e.clientX); });
    st.addEventListener("pointermove", function(e){ move(e.clientX); });
    st.addEventListener("pointerup", function(){ dragging = false; });
    st.addEventListener("pointercancel", function(){ dragging = false; });
  }
  window.FansMountPouch = mount;
  document.querySelectorAll("[data-pouch3d]").forEach(mount);   /* auto-scan al cargar (float-row home etc.) */
})();
